module.exports = __webpack_public_path__ + "media/images/webpage/hotels/theme/icon-ticket-30aaf1967ab4856d50b9c54ef38b8dc1.webp";